import React, { useState, useEffect } from 'react';
import { Button, Input, Select, message, Form, InputNumber, Space, Row, Col, Tabs, AutoComplete, Card } from 'antd';
import useWebPost from '../../utils/useWebPost';
import { checkp, dayjsDate, formatDate2, formatNumber, getAdmin, getobjkeys, getJsfs, getyhzh } from '../../utils/functions';
import FullHeightLayout from '../../components/FullHeightLayout';
import { useNavigate, useParams } from 'react-router-dom';
import ImgUploader from "../../components/ImgUploader";
import DateInput from '../../components/DateInput';

const { Option } = Select;

const ExpenditureForm = (props) => {
    const { sn } = useParams();
    const [form] = Form.useForm();
    const webPost = useWebPost();
    const [step, setStep] = useState(0);
    const [isloading, setIsloading] = useState(true);
    const [config, setConfig] = useState({});
    const [xmsn, setXmsn] = useState('');
    const [htCntent, setHtContent] = useState(null);
    const [kmdata, setKmdata] = useState([]);
    const [lyfresh, setLyfresh] = useState({});
    const [lycount, setLycount] = useState(1);
    const [lydata, setLydata] = useState({ '个人来款': null, '建设单位来款': null, '资金垫付': null });

    const can_mode = !(Number(localStorage.getItem(`st_${sn}`)) === 10 || Number(localStorage.getItem(`st_${props?.sn}`)) === 10
        || Number(localStorage.getItem(`st_${props?.item?.sn}`)) === 10);

    useEffect(() => {
        async function getCs() {
            const yhzh = await getyhzh(webPost);
            const admin = getAdmin();
            const kms = await webPost('cktypelist', {});
            if (kms) setKmdata(kms.filter(it => it.km.toLowerCase().includes('ck')));
            form.setFieldValue('maker_name', admin?.name);
            setConfig(prev => ({ ...prev, yhzh, jsfs: getJsfs(), }));
        }
        getCs();
        return undefined;
    }, []);
    useEffect(() => {
        async function getXx(s) {
            const res = await webPost('getCwxxBySn', { sn: s });
            if (res) {
                setXmsn(s);
                setHtContent(s);
                form.setFieldsValue(res);
                setStep(1);
            }
        }
        if (props) {
            if (props?.item) {
                setXmsn(props.item.sn);
                const res = props.item;
                form.setFieldsValue({ ...res });
                setHtContent(null);
                setStep(1);

                const fxs = async (id) => {
                    const res = await webPost('getCkzcList', { id });
                    if (res) {
                        console.log(res);
                        if (res?.ly && res.ly.length > 0) {
                            setLycount(res.ly.length);
                            for (let index = 0, l = res.ly.length; index < l; index++) {
                                const rs = res.ly[index];
                                let v1 = '未知';
                                if (rs.ps.includes('个人来款')) {
                                    v1 = '个人来款';
                                } else if (rs.ps.includes('建设单位来款')) {
                                    v1 = '建设单位来款';
                                } else if (rs.ps.includes('资金垫付')) {
                                    v1 = '资金垫付';
                                }
                                form.resetFields([`zfly${index}`]);
                                form.setFieldValue(`zfly_${index}`, v1);
                                form.setFieldValue(`bank_id_${index}`, rs.bank_id);
                                form.setFieldValue(`zfamt_${index}`, rs.amount);
                                await getlydata(0);
                                form.setFieldValue(`zfid_${index}`, Number(rs.id));
                            }
                        }
                    }
                };
                fxs(res.id)
                // setTimeout(() => fxs(res.id), 20);
            } else {
                if (props?.sn) getXx(props.sn);
            }
        } else {
            if (sn) getXx(sn);
        }
        return undefined;
    }, [sn, props?.sn, props?.item, props?.fkey]);


    const reCalMoney = (index) => {
        const zfid = form.getFieldValue(`zfid_${index}`);
        const zfly = form.getFieldValue(`zfly_${index}`);
        const item = (lydata[zfly] || []).find(it => Number(it.id) === Number(zfid));
        if (!item) {
            message.error('发生错误，未找到支付来源');
            return;
        }
        const this_pay = form.getFieldValue(`zfamt_${index}`);
        if (zfly !== '资金垫付') {
            if (this_pay - item.left_amount > 0) {
                message.error('不能超出剩余金额');
                form.setFieldValue(`zfamt_${index}`, item.left_amount);
            }
        }

        let total = 0;
        for (let i = 0; i < lycount; i++) {
            total += Number(form.getFieldValue(`zfamt_${i}`)) || 0;
        }
        form.setFieldValue('this_receipt_amount', total.toFixed(2));
    }

    const saveSubmit = async (sh) => {
        try {
            if (!can_mode) return;
            const values = await form.validateFields();

            if (!values.tj_date) {
                values.tj_date = values.make_date;
            }
            const id = (props?.item && props.item.id) || 0;
            const res = await webPost('expendituresq', {
                ...values, id: id, sh, sn: xmsn, lycount
            });
            if (res) {
                message.success('保存成功');
                if (id === 0) form.resetFields();
                if (props && props?.onSave) props.onSave();
            }
        } catch (errorInfo) {
            console.log('校验失败', errorInfo);
            message.error('请检查表单填写内容，有必填项未填或格式错误！');
            const firstErrorItem = document.querySelector('.ant-form-item-has-error');

            if (firstErrorItem) {
                firstErrorItem.scrollIntoView({
                    behavior: 'smooth', // 平滑滚动
                    block: 'center'    // 居中显示，防止被顶部导航栏遮挡
                });
            }
        }
        return;
    };
    const getXmxx = async () => {
        const res = await webPost('getCwxxBySn', { sn: form.getFieldValue('sn') });
        if (res) {
            setHtContent(res);
            setXmsn(form.getFieldValue('sn'));
            form.setFieldsValue(res);
            setStep(1);
        }
    }
    const getlydata = async (index) => {
        form.setFieldValue(`zfid_${index}`, '');
        const lx = form.getFieldValue('zfly_' + index);
        let tempData = lydata[lx];
        setLyfresh((prev) => ({ ...prev, [`b_${index}`]: lx }));

        form.setFieldValue(`bank_id_${index}`, undefined);
        if (tempData === null) {
            const res = await webPost('getJxk', { sn: form.getFieldValue('sn'), lx });
            if (res) {
                if (res.length === 0 && lx === '资金垫付') {
                    const newLydata = {
                        ...lydata,
                        '资金垫付': [{ id: 0, make_date: '资金垫付', kmmc: '', left_amount: 0 }]
                    };
                    setLydata(newLydata);
                    return;
                }
                const newLydata = {
                    ...lydata,
                    [lx]: res
                };
                setLydata(newLydata);
                tempData = res;
                return;
            } else {
                if (lx === '资金垫付') {
                    const newLydata = {
                        ...lydata,
                        '资金垫付': [{ id: 0, make_date: '资金垫付', kmmc: '', left_amount: 0 }]
                    };
                    setLydata(newLydata);
                    return;
                }

            }
        }
        if (tempData === null) {
            message.info('暂无可用来款');
            return;
        }
    }

    return (
        <FullHeightLayout
            headerContent={null}
            footerContent={
                step === 1 && can_mode && (<Row justify="center" style={{ width: '90%' }}>
                    <Col>
                        <Button type="link" onClick={() => saveSubmit(0)}>保存为草稿</Button>
                        <Button type="primary" onClick={() => saveSubmit(1)}>保存并提交</Button>
                    </Col>
                </Row>)
            }
        >
            <Form form={form} layout="vertical" loading={isloading}>
                {step === 0 && (<>
                    <Form.Item label="项目编号" name="sn">
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" onClick={getXmxx}>下一步</Button>
                    </Form.Item>
                </>)}
                {step === 1 && (<>
                    <h3>付款方</h3>
                    <div className='responsive-grid'>
                        <Form.Item name='receipt_company' hidden><Input /></Form.Item>

                        {/* <Form.Item label="付款账号" name="receipt_account" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item> */}
                        <Form.Item label="制单人" name="maker_name" rules={[{ required: true }]}>
                            <Input readOnly />
                        </Form.Item>
                        <Form.Item label="制单日期" name="make_date" rules={[{ required: true }]}>
                            <DateInput showTime={false} />
                        </Form.Item>
                        <Form.Item label="统计日期" name="tj_date">
                            <DateInput showTime={false} />
                        </Form.Item>
                    </div>

                    <h3>收款方</h3>
                    <div className='responsive-grid'>
                        <Form.Item label="支付类别" name="pay_type" rules={[{ required: true }]}>
                            <AutoComplete options={[{ value: '业务支付' }, { value: '分包' }, { value: '供应商' }, { value: '其它报销' }]}></AutoComplete>
                        </Form.Item>
                        <Form.Item label="结算方式" name="settlement_method" rules={[{ required: true }]}>
                            <Select placeholder="选择结算方式">{config?.jsfs && config.jsfs.map(it => <Option key={it.id} value={it.name}>{it.name}</Option>)}</Select>
                        </Form.Item>
                        <Form.Item label="收款户名" name="payer_display" rules={[{ required: true }]}>
                            <AutoComplete options={config?.yhzh ? config.yhzh.map(it => ({ value: `${it.dw}-${it.mc}-${it.zh}` })) : []}
                                onChange={(values) => {
                                    const matched = config?.yhzh.find(it => `${it.dw}-${it.mc}-${it.zh}` === values);
                                    if (matched) {
                                        form.setFieldsValue({ payer_account: matched.zh, payer_bank: matched.khh, payer_name: matched.dw });
                                    } else {
                                        form.setFieldsValue({ payer_name: form.getFieldValue('payer_display'), payer_bank: '', payer_account: '' });
                                    }
                                }} />

                        </Form.Item>
                        <Form.Item label="收款账号" name="payer_account" rules={[{ required: true }]}><Input /></Form.Item>
                        <Form.Item label="收款银行" name="payer_bank" rules={[{ required: true }]}><Input /></Form.Item>
                        <Form.Item label="费用科目" name="km" rules={[{ required: true }]}>
                            <Select
                                showSearch // 开启搜索功能
                                placeholder="输入科目代码或名称进行搜索"
                                optionFilterProp="label" // 指定搜索时匹配的是 label 属性
                                filterOption={(input, option) => {
                                    const inputLower = input.toLowerCase();
                                    const km = option.km?.toString().toLowerCase() || '';
                                    const kmmc = option.kmmc?.toLowerCase() || '';
                                    return km.includes(inputLower) || kmmc.includes(inputLower);
                                }}
                                onChange={(value) => {
                                    const matched = kmdata.find(it => it.km === value);
                                    if (matched) {
                                        form.setFieldsValue({ kmmc: matched.kmmc });
                                    }
                                }}
                            >
                                {kmdata?.map((item) => (
                                    <Select.Option
                                        key={item.km}
                                        value={item.km} // 假设表单最终存的是科目代码 km
                                        km={item.km} // 通过属性把数据传进去，供 filterOption 使用
                                        kmmc={item.kmmc}
                                        label={`${item.km} ${item.kmmc}`} // 这是给 showSearch 默认搜索用的文本
                                    >
                                        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                                            <span>{item.km}</span>
                                            <span style={{ color: '#666', fontSize: '12px' }}>{item.kmmc}</span>
                                        </Space>
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="备注" name="remark"><Input.TextArea maxLength={450} showCount /></Form.Item>
                        <Form.Item label="付款总金额（=来源支付金额合计）" name="this_receipt_amount"><Input type="number" readOnly /></Form.Item>
                    </div>
                    <div className='responsive-grid'>
                        {/* <Form.Item label="其它合同总额" name="contract_amount"><Input /></Form.Item>
                        <Form.Item label="其它合同开票金额" name="received_kpj"><Input type="number" /></Form.Item> */}
                    </div>
                    {
                        Array.from({ length: lycount }, (_, index) => (
                            <Card key={index} title={<h4 style={{ color: 'red' }}>{`支付来源${1 + index}`}</h4>}>
                                <div className='responsive-grid4'>
                                    <Form.Item label="支付来源" name={`zfly_${index}`} rules={[{ required: true }]}>
                                        <Select onChange={() => { getlydata(index) }}><Option value='个人来款'>个人来款</Option><Option value='建设单位来款'>建设单位来款</Option>
                                            <Option value='资金垫付'>资金垫付</Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item label="来源对象" name={`zfid_${index}`} rules={[{ required: true, message: '请选择来源对象' }]}>
                                        <Select onChange={v => {
                                            const zflyVal = form.getFieldValue(`zfly_${index}`);
                                            const list = lydata[zflyVal] || [];
                                            const target = list.find(it => Number(it.id) === Number(v));
                                            const fkid = target?.bank_id || undefined;
                                            form.setFieldValue(`bank_id_${index}`, fkid);
                                        }}
                                            key={`zfid_select_${index}`}
                                        >
                                            {
                                                (lydata[form.getFieldValue(`zfly_${index}`)] || []).map(it => (
                                                    <Select.Option key={it.id} value={Number(it.id)}>
                                                        <span>{`${it.make_date}-${it.kmmc}-`}</span>
                                                        <span style={{ color: it.left_amount < 0 ? 'red' : '#000' }}>
                                                            {it.left_amount}
                                                        </span>
                                                    </Select.Option>
                                                ))
                                            }

                                            {/* 空数据时显示 */}
                                            {
                                                (!lydata[form.getFieldValue(`zfly_${index}`)] ||
                                                    lydata[form.getFieldValue(`zfly_${index}`)].length === 0) && (
                                                    <Select.Option value="">--无数据--</Select.Option>
                                                )
                                            }
                                        </Select>
                                    </Form.Item>
                                    <Form.Item label="支付金额" name={`zfamt_${index}`} rules={[{ required: true }]}>
                                        <InputNumber type="number" onChange={() => reCalMoney(index)} style={{ width: '100%' }} />
                                    </Form.Item>
                                    <Form.Item label="付款账户" name={`bank_id_${index}`} rules={[{ required: true }]}>
                                        <Select disabled={lyfresh[`b_${index}`] !== '资金垫付'} placeholder="选择付款账户" onChange={(value) => {
                                            const matched = config?.yhzh.find(it => Number(it.id) === Number(value));
                                            if (matched) {
                                                console.log(`${matched.dw}-${matched.mc}`);
                                                form.setFieldsValue({ receipt_account: matched.zh, receipt_company: `${matched.dw}-${matched.mc}` });
                                            }

                                        }}>{config?.yhzh && config.yhzh.map(it => {
                                            return <Option key={it.id} value={it.id}>{`${it.dw}-${it.mc}-${it.zh}`}</Option>
                                        })}</Select>
                                    </Form.Item>
                                </div>
                            </Card>
                        ))
                    }

                    <div className='responsive-grid'>
                        <Form.Item label={<a onClick={() => { setLycount(prev => (1 + prev)); }}>增加支付来源</a>} ></Form.Item>
                        <Form.Item label={<a onClick={() => { setLycount(prev => (Math.max(prev - 1, 1))); }}>支付来源-1</a>} ></Form.Item>
                    </div>

                    <h3>业务明细</h3>
                    <div className='responsive-grid'>
                        <Form.Item label="项目编号" name="sn" rules={[{ required: true }]}><Input value={xmsn} /></Form.Item>
                        <Form.Item label="项目名称" name="xmmc" rules={[{ required: true }]} ><Input readOnly /></Form.Item>
                        <Form.Item label="合同来款合计" name="received_amount"><Input type="number" /></Form.Item>
                        <Form.Item label="合同已付款合计" name="paid_amount"><Input /></Form.Item>
                        <Form.Item label="合同余额" name="invoiced_amount"><Input /></Form.Item>
                    </div>

                    <Form.Item label="附件" name="attachment"><ImgUploader /></Form.Item>
                    <Form.Item hidden name={'kmmc'}><Input /></Form.Item>
                    <Form.Item hidden name={'payer_name'}><Input /></Form.Item>

                </>)}



            </Form >
        </FullHeightLayout >
    );
};

export default ExpenditureForm;